var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.view),expression:"!view"}],class:['am-view', 'am-view-' + this.size],attrs:{"element-loading-spinner":"el-icon-loading"}},[_c('div',{ref:"container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }